export default __webpack_public_path__ + "96a6877.png";